import { Component, OnInit, } from '@angular/core';
import { IonicModule, LoadingController, ModalController, ToastController } from '@ionic/angular';
import { ContribuicoesProvider } from 'src/app/services/contribuicoes/contribuicoes';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Browser } from '@capacitor/browser';
import { format, isBefore, parseISO } from 'date-fns';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { DateFormatPipe } from 'src/app/pipes/date-format/date-format';
import { SemRegistroComponent } from 'src/app/components/sem-registro/sem-registro';
import { MoneyPipe } from 'src/app/pipes/money/money';
@Component({
  selector: 'app-contribuicoes-parcelas',
  templateUrl: './contribuicoes-parcelas.page.html',
  styleUrls: ['./contribuicoes-parcelas.page.scss'], 
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DateFormatPipe,
    TranslateModule,
    SemRegistroComponent,
    MoneyPipe
  ],
})
export class ContribuicoesParcelasPage implements OnInit {
  carregado: boolean = false;
  boletoAbertos: any = [];
  dateToCompare: any = format(new Date(), "yyyy-MM-dd");
  animator: boolean = false;

  constructor(
    public modalCtrl: ModalController,
    public contribuicoesController: ContribuicoesProvider,
    private toastCtrl: ToastController,
    private translate: TranslateService,
    public loadingController: LoadingController,
  ) {
    this.load();
  }

  ngOnInit() {
  }

  load() {
    this.contribuicoesController.getMinhasContribuicoes().subscribe((data) => {
      this.boletoAbertos = data.boletosAbertos;
    });
  }

  isAtrasado(data: string) {
    let date = format(parseISO(data), "yyyy-MM-dd");
    const result = isBefore(new Date(date), new Date(this.dateToCompare));
    return result;
  }

  abrirBoleto(idContaReceberParcela: any) {
    this.contribuicoesController.getBoletoParcela(idContaReceberParcela).subscribe(async data => {
      if (!data.error) {
        await Browser.open({ url: data.urlPagamento });

      } else {
        const toast = await this.toastCtrl.create({
          message: this.translate.instant('Ocorreu um erro inesperado'),
          duration: 3000
        });

        toast.present();
      }
    });
  }


  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
